$(function(){

    // http://stackoverflow.com/questions/4187032/get-list-of-data-attributes-using-javascript-jquery
    function getDataAttributes(node) {
        var d = {},
            re_dataAttr = /^data\-(.+)$/;
        $.each(node.get(0).attributes, function(index, attr) {
            if (re_dataAttr.test(attr.nodeName)) {
                var key = attr.nodeName.match(re_dataAttr)[1];
                d[key] = attr.nodeValue;
            }
        });
        return d;
    }


    var ppacks = {

          $page: null
        , $pagetop: null
        , $stage: null
        , $stage_outer: null
        , $list: null
        , $list_outer: null
        , $packs: null
        , $activeAddToCartButton: $()

        , pids: []
        , includes: {}
        , includes_arr: []
        , saved_image: null
        , saved_name: null
        , saved_slug: null
        , is_dev: null
        , sub_links: false
        , hide_stage: false

        , init: function () {
            ppacks.$page = $('#power-packs');
            ppacks.$pagetop = $('#pwr-page-top');
            ppacks.$stage = ppacks.$page.find('.pwr-stage');
            ppacks.$stage_outer = ppacks.$stage.parents('.pwr-stage-outer');
            ppacks.$list = ppacks.$page.find('ul.pwr-list');
            ppacks.$list_outer = ppacks.$list.parents('.pwr-list-outer');
            ppacks.$packs = ppacks.$list.find('> li');

            if (!ppacks.$packs.length) ppacks.$packs = ppacks.$page.find('.pwr-pack');
            ppacks.sub_links = (ppacks.$page.data('sub-links'));
            ppacks.hero = (ppacks.$page.data('hero'));

            ppacks.init_packs();

            ppacks.$stage.on('click', '.pwr-button.add-to-cart', ppacks.add_to_cart);
            // ppacks.$stage.on('click', '.pwr-button.customize', ppacks.customize);
            ppacks.$page.on('change', 'select.pwr-select', ppacks.update_select);
            ppacks.$stage.on('change', 'input[type="checkbox"]', ppacks.toggle_product);
            // ppacks.$stage.on('click', 'a.pwr-pack-oos-acknowledge', ppacks.hide_oos);

            ppacks.is_dev = (location.hostname.match(/local/)) ? true : false;

            ppacks.hide_stage = (ppacks.$page.hasClass('hide-stage')) ? true : false;

        }

        , get_products: function ($pack) {
            var $products = $pack.find('img.pwr-pack-image').not('[data-stock="out-of-stock"]');
            return $products;
        }

        , calc_price: function ($pack) {
            var price = msrp = stay_onnit = 0,
                $products = ppacks.get_products($pack),
                $price, stay_onnit_str;

            $products.each(function(){
                price += parseFloat($(this).attr('data-price'));
                msrp += parseFloat($(this).attr('data-msrp'));
            });

            /* BMSM is dead ... FOR NOW */
            /*
            if (price >= 250) {
                price *= .9;
            } else if (price >= 150) {
                price *= .95;
            }
            */

            $price = (msrp > price)
                ? '<strike>$' + msrp.toFixed(2) + '</strike>&emsp;<span class="pwr-real-price">$' + price.toFixed(2) + '</span>'
                : '<span class="pwr-real-price">$' + price.toFixed(2) + '</span>';

            stay_onnit = price * .8;
            stay_onnit_str = [
                , '<a class="pwr-stay-onnit magnific mfp-inline" href="#frequency-popup">'
                , '<strike class="pwr-real-price">$', price.toFixed(2), '</strike>&emsp;&emsp;'
                , '<span class="pwr-stay-onnit-price">$', stay_onnit.toFixed(2), '</span>&emsp;&emsp;'
                , '<span class="pwr-stay-onnit-text">Autoship & Save</span>'
                , '</a>'
            ].join('');

            $price += stay_onnit_str;

            return $price;
        }

        , tally_pids: function($pack) {
            var $products = ppacks.get_products($pack);
            ppacks.pids.length = 0;

            $products.each(function(){
                ppacks.pids.push($(this).attr('data-pid'));
            });

        }

        , tally_includes: function ($pack) {
            var $products = ppacks.get_products($pack);
            ppacks.includes = {};
            ppacks.includes_arr.length = 0;

            $products.each(function(){
                var key = $(this).attr('data-name');

                if (!ppacks.includes.hasOwnProperty(key)) {
                    ppacks.includes[key] = [1, $(this).attr('data-slug')];
                } else {
                    var n = parseInt(ppacks.includes[key][0]);
                    n++;
                    ppacks.includes[key][0] = n;
                }
            });

            if (ppacks.sub_links == true) {
                $.each(ppacks.includes, function(key, value){
                    ppacks.includes_arr.push('<a href="/' + value[1] + '/" class="">' + ppacks.in_words(value[0]) + ' ' + key + '</a>');
                });
            } else {
                $.each(ppacks.includes, function(key, value){
                    ppacks.includes_arr.push('<span class="">' + ppacks.in_words(value[0]) + ' ' + key + '</span>');
                });
            }

            return ppacks.includes_arr.join('<span class="comma">, </span>');
        }

        , in_words: function(n) {
            n = parseInt(n);
            var ret = '';

            switch (n) {
                case 1: ret = ''; break;
                case 2: ret = 'Two '; break;
                case 3: ret = 'Three '; break;
                case 4: ret = 'Four '; break;
                case 5: ret = 'Five '; break;
            }

            return ret;
        }

        , init_packs: function () {
            ppacks.$packs.each(function(){
                var $pack = $(this), $price, $includes;

                $price = ppacks.calc_price($pack);
                $pack.find('.pwr-pack-price .pwr-text-well').html($price);

                $includes = ppacks.tally_includes($pack);
                $pack.find('.pwr-pack-includes .pwr-text-well').html($includes);

                if (ppacks.hero == true) {

                } else {
                    $pack.on('click', '.learn-more, .add-to-cart-2', function(e){
                        ppacks.learn_more($pack, $(this));
                    });
                }

            });

            if (window.location.pathname.indexOf('academy') > -1) {
                ppacks.$packs.eq(0).find('.learn-more').click();
            }

        }

        , learn_more: function ($pack, $button) {

            if ($button.hasClass('adding-to-cart')) return;

            ppacks.$stage_outer.removeClass('empty');

            $_pack = '<div class="pwr-pack">' + $pack.html() + '</div>';

            if (!ppacks.hide_stage) {
                ppacks.$pagetop.attr('id', $pack.attr('data-id'));
            } else {
                $button.text('Adding').addClass('adding-to-cart is-disabled');
                ppacks.$activeAddToCartButton = $button;
            }
            
            ppacks.tally_pids($pack);
            ppacks.$stage.html($_pack);
            
            if (!ppacks.hide_stage)
                ppacks.$stage.find('.pwr-pack-image-well-outer').css('padding-bottom', ppacks.$stage.find('.pwr-pack-image-well').height());

            if ($('body').hasClass('page-assessment-results')) {
                ppacks.customize();
            }

            if (ppacks.hide_stage)
                ppacks.add_to_cart();

            // $button.click();

        }

        , update_select: function (event) {

            var $select = $(event.currentTarget);

            if (!$select.hasClass('pwr-gym-select')) {

                var $parent = $select.parents('.pwr-pack'),
                    $selected = $select.find('option:selected'),
                    sel_index = $selected.index(),
                    match = $select.attr('data-match'),
                    $images = $parent.find('img.pwr-pack-image'),
                    $faux_images = $parent.find('span.pwr-pack-faux-image'),
                    $image = $images.filter('[data-match="' + match + '"]'),
                    $faux_image = $faux_images.filter('[data-match="' + match + '"]').eq(sel_index),
                    old_data = getDataAttributes($image),
                    new_data = getDataAttributes($faux_image),
                    $price,
                    $includes;

                $.each(new_data, function(key, value){
                    $image.attr('data-' + key, value);
                });
                $image.attr('src', $image.attr('data-src'));

                $price = ppacks.calc_price($parent);
                $parent.find('.pwr-pack-price .pwr-text-well').html($price);

                $includes = ppacks.tally_includes($parent);
                $parent.find('.pwr-pack-includes .pwr-text-well').html($includes);

                ppacks.tally_pids($parent);

            } else {

                var $gym_opt = ppacks.$packs.filter('[data-id="' + $select.val() + '"]');
                $gym_opt.find('.learn-more').click();

            }
        }

        , hide_oos: function (event) {
            var $this = $(event.currentTarget),
                $oos = $this.parents('.pwr-pack').find('img[data-stock="out-of-stock"]');

            $oos.fadeOut(function(){
                $this.hide();
            });
        }

        , toggle_product: function (event) {
            var $this = $(event.currentTarget),
                pid = $this.val(),
                $p = ppacks.$stage.find('[data-pid="' + pid + '"]'),
                data = getDataAttributes($p),
                $price;

            data = getDataAttributes($p);

            // https://www.youtube.com/watch?v=UODX_pYpVxk
            if (data['toggled-on'] === 'yes') {
                data['toggled-on'] = 'no';
                var $replacement = $('<span class="pwr-pack-faux-image visually-hidden" />');
                $.each(data, function(key, value){
                    $replacement.attr('data-' + key, value);
                });
                $replacement
                    .attr('data-src', $p.attr('src'))
                    .insertAfter($p);
                $p.remove();
            } else if (data['toggled-on'] === 'no') {
                data['toggled-on'] = 'yes';
                var $replacement = $('<img class="pwr-pack-image" />');
                $.each(data, function(key, value){
                    $replacement.attr('data-' + key, value);
                });
                $replacement
                    .attr('src', $p.attr('data-src'))
                    .css('height', data['scale'] + 'em')
                    .insertAfter($p);
                $p.remove();
            }

            $price = ppacks.calc_price(ppacks.$stage);
            ppacks.$stage.find('.pwr-pack-price .pwr-text-well').html($price);
            ppacks.tally_pids(ppacks.$stage);

        }

        , customize: function () {
            // var includes = '<div class="white-popup">' + ppacks.tally_includes(ppacks.$stage) + '</div>';
            var form = '<form>';
            var $products = ppacks.get_products(ppacks.$stage);

            $products.each(function(){
                var $p = $(this);
                var input = [
                      '<div class="pwr-input-group">'
                    ,     '<input type="checkbox" checked class="quiz-formfield quiz-checkbox" id="checkbox-', $p.attr('data-pid'), '" value="', $p.attr('data-pid'), '">'
                    ,     '<label for="checkbox-', $p.attr('data-pid'), '" class="quiz-formfield quiz-checkbox-label"><span></span> ', $p.attr('data-name'), '</label>'
                    , '</div>'
                ].join('');

                form += input;
            });

            form += '</form>';

            ppacks.$stage.find('.pwr-pack-includes .pwr-text-well').addClass('customize').html(form);

        }

        , add_to_cart: function () {
            ppacks.$stage_outer.addClass('adding-to-cart');
            ppacks.ajax();
        }

        , ajax: function () {
            if (typeof ga !== 'undefined') {
                var name = ppacks.$stage.find('.pwr-pack-name a').text();
                var price = ppacks.$stage.find('.pwr-real-price').text().replace(/[^0-9\.]+/, '');
                ga('send', 'event', 'Power Pack', 'Add to Cart', name, parseFloat(price));
            }

            if (!window.ONNIT.cart) {
                throw new Error("Cannot add product to cart because `window.ONNIT.cart` is undefined.");
            }

            var productConfigs = ppacks.pids.map(function(productId) {
                return {
                    product_id: Number(productId),
                    quantity: 1,
                    subscription_interval: null,
                };
            });

            window.ONNIT.cart.addProducts(productConfigs, function() {
                ppacks.$stage_outer.removeClass('adding-to-cart');
                ppacks.$activeAddToCartButton.removeClass('adding-to-cart is-disabled').text('Added');
                window.ONNIT.cart.openDrawer();
            });
        }
    };

    ppacks.init();

    if (!("Blazy" in window)) {
        $("img.pwr-pack-image.b-lazy").each(function (index, element) {
            element.src = element.getAttribute("data-src");
            element.classList.add("b-loaded");
            element.classList.remove("b-lazy");
            console.log(element.classList);
            element.removeAttribute("data-src");
        });
    }
});
